import React from 'react';
import { useIntl } from 'react-intl';
import { TableRow as Row, TableCell } from '@mui/material';

export default function TableRow({
  columns,
  rowVariant = 'body',
  hover,
  selected,
  onOpenDetails,
  selectedStyle = {},
  rowData,
}) {
  const intl = useIntl();

  return (
    <Row
      selected={selected}
      hover={hover}
      onClick={rowVariant === 'body' ? onOpenDetails : undefined}
      sx={{
        cursor: rowVariant === 'body' && onOpenDetails ? 'pointer' : 'auto',
        opacity: 1,
      }}
    >
      {columns.map(
        ({
          id,
          alignment,
          label,
          styles,
          translatable = true,
          fallback,
          formatCallback,
        }) => (
          <TableCell
            key={id}
            align={alignment}
            variant={rowVariant}
            sx={{ ...styles, ...(selected ? selectedStyle : {}) }}
          >
            {(label === null || label === undefined) && fallback
              ? fallback
              : null}
            {formatCallback && rowVariant === 'body'
              ? formatCallback(
                  typeof label === 'string' && translatable
                    ? intl.messages[label]
                    : label,
                  rowData
                )
              : typeof label === 'string' &&
                  translatable &&
                  rowVariant === 'head'
                ? intl.messages[label]
                : label}
          </TableCell>
        )
      )}
    </Row>
  );
}
